import { useEffect } from "react";
import { useData, useService, useSession } from "contexts";

type Props = {
  children: React.ReactNode;
};

export const LoadData = ({ children }: Props) => {
  const { isAuthenticated, user } = useSession();
  const { configurationService, userService } = useService();
  const { setUser, setConfigurations } = useData();

  useEffect(() => {
    fetchConfigurations();
  }, []);

  useEffect(() => {
    fetchUser();
  }, [isAuthenticated]);

  async function fetchUser() {
    if (!isAuthenticated) return setUser(null);
    setUser(await userService.findById(user.id));
  }

  async function fetchConfigurations() {
    setConfigurations(await configurationService.all());
  }

  return <>{children}</>;
};
